<div class="dash-card no-padding">
    <div class=" dash-card-header">
        <h2>Resumo</h2>
    </div>

    <div class="dash-card-body padding-container mb-5">
        <div class="col-12" style="padding: 0 30px 20px;">
            <div class="row">
                <div class="col-lg-6">
                    <p class="title">Empresa</p>
                    <p class="label">
                        {{formatDocument(data?.document_number)}} |
                        {{data?.corporate_name}}
                    </p>
                </div>

                <div class="col-lg-3">
                    <p class="title">Papel</p>
                    <p class="label">
                        {{data?.role}}
                    </p>
                </div>

                <div class="col-lg-3">
                    <p class="title">Criado por</p>
                    <p class="label">
                        {{data?.owner ??
                        user.active_register.register.name}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="dash-card no-padding">
    <div class=" dash-card-header">
    </div>

    <div class="dash-card-body padding-container mb-5">
        <table class="bordered">
            <thead>
                <tr>
                    <th>Perfil de usuários</th>
                    <th>Papel</th>
                    <th>Tipos de usuários</th>
                </tr>
            </thead>

            <tbody *ngFor="let item of data?.profiles">
                <tr>
                    <td>
                        {{item?.label}}
                    </td>

                    <td>
                        {{item?.label}}
                    </td>

                    <td>
                        {{item?.label}}
                    </td>
                </tr>
            </tbody>
            <app-spacer [bottom]="28"></app-spacer>
        </table>
    </div>
</div>

<div class="d-flex justify-content-between">
    <app-button (onClick)="handleCancel()" [disabled]="sendingRequest"
        [phantom]="true">
        Cancelar
    </app-button>

    <app-button (onClick)="handleAdd()" class="add-button"
        [loading]="sendingRequest">
        Associar perfis de usuários
    </app-button>
</div>